<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="'Receitas da OAB'"></Title>

        <div class="container items-container">

          <div class="row">
            <div class="col-12 col-md-2">
              <YearsFilter></YearsFilter>
            </div>
            <!-- /.col-12 col-md-2 -->

            <div class="col-12 col-md-4">
              <BranchsFilter></BranchsFilter>
            </div>
            <!-- /.col-12 col-md-4 -->
          </div>
          <!-- /.row -->

          <Loading :loading="loading"></Loading>

          <div :class="{ 'row d-xl-none hidden': loading, 'row d-xl-none': !loading }">
            <div class="col-12">
              <div class="accordion" id="receitas">

                <div class="card" v-for="(income, key) in incomesMobile">
                  <div class="card-header js-accordion-header" :id="'income-' + key">
                    <h5 class="mb-0">
                      <button :class="{'btn btn-link collapsed': key, 'btn btn-link': !key}" type="button" data-toggle="collapse" :data-target="'#content-' + key">
                        {{ income.month }}
                      </button>
                    </h5>
                  </div>

                  <div :id="'content-' + key" :class="{'collapse show' : !key, 'collapse': key}" data-parent="#receitas">
                    <div class="card-body">

                      <ul class="incomes-mobile">
                        <li class="incomes-mobile-item" v-for="incomeType in income.incomes">

                          <router-link
                            :to="`/orcamentosefinancas/receitas/${branch}/${year}/` + incomeType.link"
                            v-if="incomeType.value"
                          >
                            <span>{{ incomeType.name }}:</span>
                            <strong>{{ incomeType.value.toLocaleString('pt-BR') }}</strong>
                          </router-link>

                          <p class="incomes-mobile-item-zerado" v-else>
                            <span>{{ incomeType.name }}:</span>
                            <strong>0</strong>
                          </p>
                        </li>
                        <!-- /.incomes-mobile-item -->

                        <li class="incomes-mobile-total">
                          <span>Total:</span>
                          <strong>{{ income.total.toLocaleString('pt-BR') }}</strong>
                        </li>
                        <!-- /.incomes-mobile-total -->
                      </ul>
                      <!--== /.incomes-mobile ==-->

                    </div>
                    <!--== /.card-body ==-->
                  </div>
                  <!--== /.collapse ==-->
                </div>
                <!--== /.card ==-->
              </div>
              <!--== /.accordion ==-->
            </div>
            <!-- /.col-12 -->
          </div>
          <!-- /.row -->

          <div :class="{ 'row d-none d-xl-block mt-3 hidden': loading, 'row d-none d-xl-block mt-3': !loading }">
            <div class="col-12">
              <table class="table income-table table-striped">
                <thead>
                <tr>
                  <th></th>
                  <th>Janeiro</th>
                  <th>Fevereiro</th>
                  <th>Março</th>
                  <th>Abril</th>
                  <th>Maio</th>
                  <th>Junho</th>
                  <th>Julho</th>
                  <th>Agosto</th>
                  <th>Setembro</th>
                  <th>Outubro</th>
                  <th>Novembro</th>
                  <th>Dezembro</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(income, key) in incomesDesktop.incomes">
                  <td :class="{'first-td': !key}">
                    {{ income.name }}
                  </td>

                  <td v-for="month in income.months">
                    <router-link
                      :to="`/orcamentosefinancas/receitas/${branch}/${year}/` + month.link"
                      v-if="month.value"
                    >
                      {{ month.value.toLocaleString('pt-BR') }}
                    </router-link>

                    <p v-else>
                      0
                    </p>
                  </td>
                </tr>

                <tr>
                  <td>
                    <span style="color: #333333;font-weight: 700;">Total Mensal</span>
                  </td>

                  <td class="total-mensal" v-for="(total, key) in incomesDesktop.totais">
                    {{ total.total.toLocaleString('pt-BR') }}
                  </td>
                </tr>

                <tr class="total-anual" align="right">
                  <td colspan="13">
                    <span>Total do ano: R$ {{ (incomesDesktop.total_do_ano) ? incomesDesktop.total_do_ano.toLocaleString('pt-BR') : 0 }}</span>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            <!-- /.col-12 -->
          </div>
          <!-- /.row d-none -->

        </div>
        <!-- /.container -->

      </div>
      <!--== /.hidden ==-->
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Arquivo from '../../components/generic/Arquivo.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import YearsFilter from '../../components/generic/Filters/Years.vue';
  import BranchsFilter from '../../components/generic/Filters/Branchs.vue';
  import axios from 'axios';
  import env from '../../config/env';

  export default {
    name: 'receitas',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Arquivo,
      Title,
      Loading,
      YearsFilter,
      BranchsFilter,
    },
    data () {
      return {
        loading: true,
        branch: this.$route.params.branch,
        year: this.$route.params.year,
        incomesMobile: [],
        incomesDesktop: [],
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Orçamentos e Finanças',
            link: '/orcamentosefinancas'
          },
          {
            name: 'Receitas da OAB'
          }
        ]
      }
    },
    methods: {
      requestData() {
        if (screen.width >= 1200) {
          axios
            .get(`${env.api.RECEITA_DESKTOP}/${this.$route.params.branch}/${this.$route.params.year}`)
            .then(response => {
              this.incomesDesktop = response.data;
              this.loading = false;
              this.year = this.$route.params.year;
              this.branch = this.$route.params.branch;
            });
        } else {
          axios
            .get(`${env.api.RECEITA_MOBILE}/${this.$route.params.branch}/${this.$route.params.year}`)
            .then(response => {
              this.incomesMobile = response.data;
              this.loading = false;
              this.year = this.$route.params.year;
              this.branch = this.$route.params.branch;
            });
        }
      }
    },
    mounted () {
      this.requestData();
    },
    computed : {
      total: function() {
        if (!this.expenses) return 0;

        return this.expenses.reduce((sum, item) => sum + item.price, 0);
      }
    },
    watch: {
      '$route' () {
        this.loading = true;

        this.requestData();
      }
    }
  };

  jQuery(document).ready(function ($) {
    $(document).on('click', '.js-accordion-header', function (e) {
      e.preventDefault();

      let that = $(this);

      setTimeout(function() {
        $('html, body' ).animate({scrollTop: that.offset().top - $('.js-header').innerHeight()}, 1000);
      }, 1000);
    });
  }(jQuery));
</script>

<style lang="scss" scoped>
  input,
  select,
  .btn {
    box-shadow: none !important;
  }

  input,
  select {
    height: 40px;

    box-shadow: none;
  }

  form {
    .btn {
      width: 100%;
      height: 40px;
    }
  }

  p {
    margin: 0;

    text-align: center;
  }

  .accordion {
    margin-top: 30px;
  }

  .incomes-mobile {
    padding: 0;

    font-family: 'Lato', sans-serif;

    list-style: none;

    strong,
    span {
      display: inline-block;

      line-height: 1.2;
    }

    strong {
      margin-right: 10px;

      font-weight: 700;
    }

    li {
      display: flex;
      justify-content: space-between;

      padding: 10px 0;

      & + li {
        border-top: 1px solid #dddddd;
      }
    }
  }

  .income-table {
    font-family: 'Lato', sans-serif;

    td {
      padding: .7rem !important;
    }

    th,
    td {
      font-size: 12px;
      line-height: 1.2;

      vertical-align: middle
    }

    .first-td {
      font-size: 12px;
    }

    a {
      display: block;

      text-align: center;
      color: #c34338;
    }
  }

  .total-mensal {
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    color: #c34338;
    text-align: center;
  }

  .total-anual {
    font-family: 'Lato', sans-serif;
    font-weight: 700;
    color: #333333;

    td {
      padding: 0 !important;
      font-size: 14px !important;
    }

    span {
      display: inline-block;
      padding: 12px;

      background-color: #eeeeee;
      border: 1px solid #dee2e6;
    }
  }

  .incomes-mobile-item-zerado,
  .incomes-mobile-item {
    &,
    a {
      display: flex;
      justify-content: space-between;
      width: 100%;

      color: #252a2e;

      strong {
        color: #c34338;
      }
    }
  }

  /* ACCORDIONS */

  .card-header {
    padding: 0 !important;

    button {
      width: 100%;
      padding: 15px 10px !important;

      font-family: 'Lato', sans-serif;
      font-weight: 700;
      color: #ffffff;

      text-decoration: none;

      background-color: #c34338;
      border-radius: 0;

      &.collapsed {
        color: #333333;

        background-color: #f8f8f8 !important;
      }
    }
  }
</style>
